import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useRef, useState, useEffect } from 'react';
import { throttle } from 'lodash';
import { useExecutionTimer } from '@elliemae/ds-utilities/hooks';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function usePopoverProviderState(_ref) {
  var _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === void 0 ? {
    reference: null,
    visible: false,
    value: '',
    options: {}
  } : _ref$initialState,
      delay = _ref.delay;
  var triggerRef = useRef();

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      tooltipState = _useState2[0],
      setTooltipState = _useState2[1];

  var show = function show(state) {
    setTooltipState(function (prevState) {
      return _objectSpread(_objectSpread(_objectSpread({}, prevState), state), {}, {
        visible: true
      });
    });
  };

  var hide = function hide(state) {
    setTooltipState(function (prevState) {
      return _objectSpread(_objectSpread(_objectSpread({}, prevState), state), {}, {
        visible: false
      });
    });
  };

  var _useExecutionTimer = useExecutionTimer(show, hide, delay),
      _useExecutionTimer2 = _slicedToArray(_useExecutionTimer, 2),
      showTooltip = _useExecutionTimer2[0],
      hideTooltip = _useExecutionTimer2[1];

  var handleShowTooltip = function handleShowTooltip(state, e) {
    triggerRef.current = e.target;
    showTooltip(_objectSpread(_objectSpread({}, state), {}, {
      reference: e.target
    }));
  };

  var handleHideTooltip = function handleHideTooltip(state) {
    hideTooltip(state);
  };

  useEffect(function () {
    window.addEventListener('scroll', throttle(handleHideTooltip, 300), true);
    window.addEventListener('click', handleHideTooltip, true);
    return function () {
      window.removeEventListener('scroll', throttle(handleHideTooltip, 300), true);
      window.addEventListener('click', handleHideTooltip, true);
    };
  }, [tooltipState.reference]);
  return {
    show: handleShowTooltip,
    hide: handleHideTooltip,
    state: tooltipState
  };
}

export default usePopoverProviderState;
//# sourceMappingURL=usePopoverProviderState.js.map
